// extracted by mini-css-extract-plugin
export default {"sectionImageContainer":"styles_sectionImageContainer__ap+dY"};